import { Button } from "antd";
import React from "react";
import OtpInput from "react-otp-input";
import { ToastContainer, toast } from "react-toastify";
const OtpModal = ({ isVisible, onClose, setOtp, otp ,handleVerify}) => {
  const customInputStyle = {
    width: "50px",
    height: "50px",
    margin: "0 10px",
    fontSize: "24px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    textAlign: "center",
  };

  const ResendEmail = async () => {};

  // const handleVerify = async () => {
  //   if (!otp) {
  //     toast.error("Please enter the OTP");
  //     return;
  //   }
  //   // Verification logic here
  // };

  return (
    <>
      <div className="contentCard flex min-h-[350px] flex-col items-center justify-center">
        <h2 className="mb-4 font-poppins text-[1.2rem] font-semibold text-[#3860A4]">
          Please enter your verification PIN here
        </h2>

        <div className="flex items-center justify-center">
          <OtpInput
            value={otp}
            onChange={setOtp}
            inputType="password"
            numInputs={4}
            renderSeparator={<span>-</span>}
            renderInput={(props) => <input {...props} />}
            inputStyle={customInputStyle}
          />
        </div>
        <div className="mt-12 flex justify-center space-x-3">
          {/* <button
            className="cursor-pointer rounded-[10px] border border-[#d97228] px-8 py-4"
            onClick={handleVerify}
          >
            Verify
          </button> */}

<Button
        className="btn-gradient ml-auto mr-auto flex w-40 items-center justify-center p-5 text-[white]"
        onClick={handleVerify}

      >
        Verify
      </Button>

      <Button
        className="btn-gradient ml-auto mr-auto flex w-40 items-center justify-center p-5 text-[white]"
        onClick={() => {
          setOtp("");
        }}
      >
        Clear
      </Button>
          {/* <button
            className="cursor-pointer rounded-[10px] border border-[#d97228] px-8 py-4"
            onClick={() => {
              setOtp("");
            }}
          >
            Clear
          </button> */}
        </div>
      </div>
    </>
  );
};

export default OtpModal;
